import { useEffect } from "react";

export const SEO = ({ title, desc }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (desc) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", desc);
      let og = document.querySelector('meta[property="og:title"]');
      if (og && title) og.setAttribute("content", title);
      let ogd = document.querySelector('meta[property="og:description"]');
      if (ogd) ogd.setAttribute("content", desc);
    }
  }, [title, desc]);
  return null;
};

export default SEO;
